module.exports = __webpack_public_path__ + "static/media/Logo.9bc86c1a.svg";